import React from "react";
import PropTypes from "prop-types";
import { Button, Dialog, Typography } from "@mui/material";
import clsx from "clsx";

import SpinningCloseButton from "components/SpinningCloseButton";
import FacePresenter from "presenters/FacePresenter";

import useStyles from "./useStyles";

const CVPModal = (props) => {
  const { castingOrphanFaces, onClose, handleGoToFacePage, handleGoToPeoplePage } = props;
  const classes = useStyles();

  return (
    <Dialog
      classes={{ root: classes.root }}
      PaperProps={{ classes: { root: clsx(classes.paper) } }}
      open
      onBackdropClick={() => onClose()}
    >
      <SpinningCloseButton onClick={onClose} />

      <div className={classes.content}>
        <Typography align="center" variant="h4" className={classes.title}>
          These faces don&apos;t have a name:
        </Typography>
        <div className={classes.faces}>
          {castingOrphanFaces &&
            castingOrphanFaces.map((face) => (
              <img
                src={FacePresenter.asset(face)}
                alt="face"
                className={classes.facePic}
                key={FacePresenter.id(face)}
              />
            ))}
        </div>
        <div className={classes.description}>
          You can add relation, name and birthday or group faces to make your life easier!
        </div>

        <Button variant="contained" color="primary" size="large" onClick={handleGoToFacePage}>
          Add Info!
        </Button>
        <Button variant="text" color="primary" onClick={handleGoToPeoplePage}>
          Edit all faces
        </Button>
      </div>
    </Dialog>
  );
};

CVPModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  castingOrphanFaces: PropTypes.arrayOf(PropTypes.shape()),
  handleGoToFacePage: PropTypes.func.isRequired,
  handleGoToPeoplePage: PropTypes.func.isRequired,
};

export default CVPModal;
